import { useEffect, useState } from "react";

export const VOICE_SENDING_SETTLE_MS = 350;

/** Hide brief capture restarts between finalizing and dispatching a live turn. */
export function useVoiceSendingTransition<T extends string>(
  phase: T,
  live: boolean,
  quietPhase: T,
): T {
  const [displayed, setDisplayed] = useState(phase);
  const settling = live && phase === quietPhase && displayed === "sending";

  useEffect(() => {
    if (!settling) {
      setDisplayed(phase);
      return;
    }
    const timer = window.setTimeout(
      () => setDisplayed(phase),
      VOICE_SENDING_SETTLE_MS,
    );
    return () => window.clearTimeout(timer);
  }, [phase, settling]);

  // Speech, playback, errors and stopping are reflected immediately.
  return settling ? displayed : phase;
}
